// import request from '@/utils/userrequet'
import request from '@/utils/login-request'

export function gituser() {
  return request({
    url: `/department/get/${process.env.VUE_APP_COMPANY_ID}/tree`, // 正式
    // url: '/department/get/215/tree', // 测试
    method: 'get'
  })
}
// url: '/user-service/department/get/117/tree',测试，集团本部数据  .正式50是鹏展万国

export function gitusers(query) {
  return request({
    url: '/user/get/dingTaikUser/' + query.departmentId,
    method: 'get'
  })
}
export function companytree() {
  return request({
    url: '/company/get/tree',
    method: 'get'
  })
}

export function getDepartmentInfo(departmentId) {
  return request({
    url: '/department/get/' + departmentId,
    method: 'get'
  })
}
// 钉钉所有员工
export function getDDusers(id) {
  return request({
    url: `user/get/dingTaikUser/${id}`,
    method: 'get'
  })
}
// 钉钉所有员工---为了兼容测试环境
export function getDDusersTest(id) {
  const params = {
    state: 1,
    udId: id,
    pageSize: 9999
  }
  return request({
    url: `/user/get/list`,
    method: 'get',
    params
  })
}
// 钉钉部门架构
export function getDepartTree() {
  return request({
    url: `/department/get/${process.env.VUE_APP_COMPANY_ID}/tree`, // 上正式环境时换这个ID
    // url: '/department/get/215/tree', // 测试
    method: 'get'
  })
}
